/**
 * A pull request's demo as its page shows it, read from the pull request's demo session
 * (`readPullRequestDemo`). No server imports: the page reads these too.
 */
export type PullRequestDemo =
  /** The session's agent is filming and has shared no video yet. */
  | { state: 'recording'; sessionId: string }
  /**
   * The last video a turn shared, the one the description links. `updating` while a later turn
   * runs, which may share a new take.
   */
  | { state: 'ready'; sessionId: string; video: PullRequestDemoVideo; updating: boolean }
  /** The turns ended without a video: the agent saw nothing to film, or a person stopped it. */
  | { state: 'no_demo'; sessionId: string; reason: string | null }
  /** The session or its last turn failed before any video was shared. */
  | { state: 'failed'; sessionId: string };

export type PullRequestDemoVideo = {
  /** The shared file's attachment ID (`codeAttachmentUrl`). */
  id: string;
  caption: string;
  /** When the turn that shared it ended. */
  recordedAt: string;
};

/** No demo when the pull request has none, or the viewer may not read its session. */
export type PullRequestDemoResponse = { demo: PullRequestDemo | null };

/** Whether cubic is still filming, so the page reads the demo again soon. */
export function isPullRequestDemoInProgress(demo: PullRequestDemo | null | undefined): boolean {
  return demo?.state === 'recording' || (demo?.state === 'ready' && demo.updating);
}
